import { render, staticRenderFns } from "./consultarElaboracao.vue?vue&type=template&id=5579e544&scoped=true"
import script from "./consultarElaboracao.vue?vue&type=script&lang=js"
export * from "./consultarElaboracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5579e544",
  null
  
)

export default component.exports